<app-page-header [title]="pageTitle" translateTitle="no" icon="notes"></app-page-header>
<div [@fadeInOut] class="page-content">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a mat-tab-link
      routerLink=".."
      [active]="false">
      Detaljer
    </a>
    <a mat-tab-link
      routerLink="."
      [active]="true">
      Aspekter
    </a>
  </nav>

  <mat-tab-nav-panel #tabPanel>
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="flex-col gap-1em">
          <mat-form-field class="flex-1">
            <mat-label>{{'globalTexts.SearchInstruction' | translate}}</mat-label>
            <input [(value)]="currentSearchText" matInput (keyup)="applyFilter($event.target.value)">
          </mat-form-field>
        </div>

        <div [ngClass]="aspectGroupId ? '' : 'mat-elevation-z8'">
          @if (loadingIndicator) {
            <mat-progress-bar mode="query"></mat-progress-bar>
          }
          <mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Namn </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="enabled">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Aktiv </mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.enabled | boolYesNoTranslator }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="description">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Beskrivning </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.description}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Skapad </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.createdDate | dateFormatter:true }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="updatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Ändrad </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.updatedDate | dateFormatter:true }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef class="flex-100px justify-center">
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="flex-100px justify-center">
                <button mat-icon-button matTooltip="{{'commands.Edit' | translate}}" [routerLink]="['./aspect', row.aspectId]">
                  <mat-icon>edit</mat-icon>
                </button>
                @if (hasPermissionToDelete()) {
                  <button mat-icon-button matTooltip="{{'commands.Delete' | translate}}" (click)="confirmDelete(row)">
                    <mat-icon color="warn">delete</mat-icon>
                  </button>
                }
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;">
            </mat-row>
          </mat-table>

          <mat-paginator hidePageSize="true" pageSize="15" [pageSizeOptions]="[5, 10, 25, 100]" class="customPaginator"></mat-paginator>

          @if (hasPermissionToChange()) {
            <section class="button-container">
              <button mat-fab color="primary" matTooltip="{{'commands.Add' | translate}}" [routerLink]="['./aspect']"><mat-icon>add</mat-icon></button>
            </section>
          }

        </div>
      </mat-card-content>
    </mat-card>
  </mat-tab-nav-panel>
</div>
